module.exports = __webpack_public_path__ + "img/hardware.d12b5371.svg";